var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame109(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 76,
    viewBox: "0 0 56 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2168 29.7652L4.92326 36.9197C5.93894 32.8734 15.6719 27.6566 20.4115 25.554L20.2168 29.7652Z",
    fill: "#C0FFF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5044 19.1918L11.2147 13.4393L7.64948 18.0538L20.3417 23.4364L22.5044 19.1918Z",
    fill: "#567793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44833 47.4011L2.30814 44.1428L7.39456 45.9482L12.9755 45.1862L21.5915 48.1506L19.3997 52.2959L11.5087 50.2452L5.495 49.5407L1.44833 47.4011Z",
    fill: "#87D5CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5749 59.4325L21.0463 56.5317L38.6811 53.6962L39.7222 56.5832L22.5749 59.4325Z",
    fill: "#E0B598"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4975 39.3613C42.5444 38.9862 43.2946 40.6194 43.4294 41.8622C43.7346 44.6756 46.2777 50.5629 47.7018 53.1158L50.7535 54.2099L51.9741 55.6167L48.4647 41.8622C48.4647 41.3932 46.4506 39.7365 44.4975 39.3613Z",
    fill: "#87D5CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1369 23.0291L35.1533 21.1535L46.7497 10.6553L51.0221 13.8073L37.1369 23.0291Z",
    fill: "#C0FFF6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2895 35.8682L22.5469 37.71L28.7178 42.4169L35.9858 47.3285L38.5914 45.4867L37.22 44.0541L31.8719 39.8588L25.2895 35.8682Z",
    fill: "#567793"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7902 34.828L30.8723 28.576L29.0412 27.1692H30.8723L28.2783 24.8247L32.5507 27.1692L30.8723 24.8247L32.5507 25.7625L31.6352 23.2617L42.7738 32.6398L40.7902 34.828Z",
    fill: "#E0B598"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 10.9288C13.3059 9.92191 14.3751 7.81072 21.5384 7.42096C30.4924 6.93376 38.7578 7.32352 41.5129 8.4928C43.3824 9.28623 43.4808 10.9288 43.3824 10.9288M13.6666 10.9288C13.6666 16.97 8.84522 56.1408 8.84522 56.1408C8.82323 56.4761 8.80872 56.8008 8.80117 57.1152M13.6666 10.9288C18.3897 12.3904 30.9451 14.4366 43.3824 10.9288M43.3824 10.9288C43.3037 10.9288 46.2359 41.7197 47.7118 57.1152M47.7118 57.1152C48.0398 59.3238 46.7279 65.4009 42.792 67.1515C31.1812 72.3158 18.98 70.2696 12.6827 66.4694C11.6547 65.8491 8.63969 63.8352 8.80117 57.1152M47.7118 57.1152C29.0559 65.8458 13.9981 60.753 8.80117 57.1152",
    stroke: "black",
    strokeWidth: 1.14603
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame109);
export default __webpack_public_path__ + "static/media/Frame109.b9a83eb529c189bddff75e6e446bf79e.svg";
export { ForwardRef as ReactComponent };